(function () {

    "use strict";


    HSimplePaginationComponent.$inject = ['$timeout'];
    function HSimplePaginationComponent($timeout) {

        var self = this;

        var defaultLabelGetter = function (inputs) {
            return $filter('translate')('page')+ ' ' + (inputs.page + 1) + '/' + (self.lastPage + 1);
        };

        self.options = [];

        self.onSelectChange = function () {
            $timeout(function(){
                self.ngChange({selected: self.selected()});
            });
        };

        self.validNgModel = function () {
            return self.ngModel !== null && !isNaN(self.ngModel) && self.ngModel >= 0  && self.ngModel <= self.lastPage ;
        };

        self.move = function (value) {
            var newValue = self.ngModel + value;
            if (newValue === self.options.length || newValue < 0) {
                return;
            }
            self.ngModel = newValue;
            self.onSelectChange();
        };

        var init = function () {

            if (
                (isNaN(self.ngModel) || isNaN(self.lastPage)) ||
                (self.ngModel > self.lastPage) ||
                (self.ngModel < 0 || self.lastPage < 0)
            ) {
                self.options = [];
                return;
            }

            var getOptionLabel = self.labelGetter;
            if (typeof getOptionLabel  !== 'function') {
                getOptionLabel = defaultLabelGetter;
            }

            var options = [];

            for (var page = 0; page <= self.lastPage; page++) {
                options.push({
                    value: page,
                    label: getOptionLabel({page: page})
                });
            }

            self.options = options;

        };

        self.selected = function() {
            return  _.find(self.options, function (option) {
                return option.value === self.ngModel;
            });
        };

        self.$onInit = function () {
            init();
        };

        self.$onChanges = function (changesObj) {
            init();
        };

        self.$onDestroy = function () {

        };
    }

    var HSimplePaginationComponentOptions = {
        bindings: {
            ngModel: '=',
            ngChange: '&',
            disabled: '<',
            lastPage: '<',
            labelGetter: '&?',
        },
        controller: HSimplePaginationComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-simple-pagination/h-simple-pagination.component.html'
    };

    angular
        .module('components')
        .component('hSimplePagination', HSimplePaginationComponentOptions);


})();


